import React, { Component } from "react";

import {
  Row,
  Col,
  Card,
  CardHeader,
  CardBody,
  Button,
  Label,
  Alert
} from "reactstrap";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import LoadingScreen from "react-loading-screen";

import Page from "components/Page";
import { encriptarTrama, encriptarContrasenia } from "../../utils/Encriptar";
import {
  cambiarContraseniaFetch,
  limpiarCambioContrasenia
} from "../../redux/actions/aLogin";

import logo from "assets/img/logo/logo_aig_login-2.png";
import { Textbox } from "react-inputs-validation";

class CambiarContrasenia extends Component {
  constructor(props) {
    super(props);
    this.state = {
      contraseniaActual: "",
      contraseniaNueva: "",
      contraseniaNuevaConfirmar: "",
      validate: false,
      hasContraseniaActualError: true,
      hasContraseniaNuevaError: true,
      hasConfirmacionError: true
    };
    this.validateForm = this.validateForm.bind(this);
  }
  componentDidMount() {
    this.props.limpiarDatos();
  }

  handleOnClick = () => {
    var datosCambio = {
      cliCodigoCore: this.props.datosUsuario.dataUsuario.cliCodigoCore,
      cliPasswordAnterior: encriptarContrasenia(this.state.contraseniaActual),
      cliPasswordNueva: encriptarContrasenia(this.state.contraseniaNueva),
      cliPasswordNuevaSinEncriptar: this.state.contraseniaNueva
    };

    datosCambio = JSON.stringify(datosCambio);
    //console.log(datosCambio);
    const encrypted64Cambio = encriptarTrama(datosCambio);
    this.props.cambiarContrasenia(encrypted64Cambio);
  };
  toggleValidating(validate) {
    this.setState({ validate });
  }
  validateForm(e) {
    e.preventDefault();
    this.toggleValidating(true);
    const {
      hasContraseniaActualError,
      hasContraseniaNuevaError,
      hasConfirmacionError
    } = this.state;
    //console.log("All validated!", this.state);
    if (
      !hasContraseniaActualError ||
      !hasContraseniaNuevaError ||
      !hasConfirmacionError
    ) {
      this.handleOnClick();
      //console.log("All validated!");
    }
  }

  render() {
    const {
      validate,
      contraseniaActual,
      contraseniaNueva,
      contraseniaNuevaConfirmar
    } = this.state;
    let isLoading =
      this.props.datosCambioContrasenia.cambiarContraseniaIsLoading ===
        undefined
        ? false
        : this.props.datosCambioContrasenia.cambiarContraseniaIsLoading;
    return (
      <LoadingScreen
        loading={isLoading}
        bgColor="#f1f1f1"
        spinnerColor="#001871"
        textColor="#676767"
        logoSrc={logo}
        text="Cargando..."
      >
        <main className="cr-app bg-light">
          <div className="cr-content container-fluid">
            <Page title="Cambiar de Contraseña" breadcrumbs={[{ name: "Formulario para Cambiar Contraseña", active: true }]}>
              <Row>
                <Col xl={12} lg={12} md={12}>
                  <Card>
                    <CardHeader>Cambiar de Contraseña</CardHeader>
                    <CardBody>
                      <form onSubmit={this.validateForm}>
                        <Label for="exampleEmail">Contraseña Actual*</Label>
                        <Textbox
                          tabIndex="1"
                          type="password"
                          value={contraseniaActual}
                          name="actualcontrasena"
                          id="actualcontrasena"
                          placeholder="Ingresa tu contraseña actual"
                          classNameInput={"form-control"}
                          onChange={(contraseniaActual, e) => {
                            this.setState({ contraseniaActual: contraseniaActual });
                            this.props.limpiarDatos();
                            //handleChangeCorreo(e)
                          }}
                          validate={validate}
                          validationCallback={res => this.setState({ hasContraseniaActualError: res, validate: false })} // Optional.[Func].Default: none. Return the validation result.
                          onBlur={e => this.setState({ blur: true })} // Optional.[Func].Default: none. In order to validate the value on blur, you MUST provide a function, even if it is an empty function. Missing this, the validation on blur will not work.
                          validationOption={{
                            name: "actualcontrasena", // Optional.[String].Default: "". To display in the Error message. i.e Please enter your ${name}.
                            check: true, // Optional.[Bool].Default: true. To determin if you need to validate.
                            required: true,
                            msgOnError: "Por favor ingrese su contraseña" // Optional.[Bool].Default: true. To determin if it is a required field.
                          }}
                        />

                        <Label for="examplePassword">Nueva Contraseña*</Label>
                        <Textbox
                          tabIndex="1"
                          type="password"
                          value={contraseniaNueva}
                          name="nuevacontrasena"
                          id="nuevacontrasena"
                          placeholder="Ingresa una contraseña nueva"
                          classNameInput={"form-control"}
                          onChange={(contraseniaNueva, e) => {
                            this.setState({ contraseniaNueva: contraseniaNueva });
                            this.props.limpiarDatos();
                            //handleChangeCorreo(e)
                          }}
                          validate={validate}
                          validationCallback={res => this.setState({ hasContraseniaNuevaError: res, validate: false })} // Optional.[Func].Default: none. Return the validation result.
                          onBlur={e => this.setState({ blur: true }) } // Optional.[Func].Default: none. In order to validate the value on blur, you MUST provide a function, even if it is an empty function. Missing this, the validation on blur will not work.
                          validationOption={{
                          name: "nuevacontrasena", // Optional.[String].Default: "". To display in the Error message. i.e Please enter your ${name}.
                          check: true, // Optional.[Bool].Default: true. To determin if you need to validate.
                          required: true,
                          msgOnError: "Por favor ingrese su contraseña nueva" // Optional.[Bool].Default: true. To determin if it is a required field.
                        }}
                        />

                        <Label for="examplePassword">
                          Confirmar Nueva Contraseña*
                        </Label>
                        <Textbox
                          tabIndex="1"
                          type="password"
                          value={contraseniaNuevaConfirmar}
                          name="nuevacontrasenaconfirmar"
                          id="nuevacontrasenaconfirmar"
                          placeholder="Reingrese su nueva contraseña"
                          classNameInput={"form-control"}
                          onChange={(contraseniaNuevaConfirmar, e) => {
                            this.setState({
                              contraseniaNuevaConfirmar: contraseniaNuevaConfirmar
                            });
                            this.props.limpiarDatos();
                            //handleChangeCorreo(e)
                          }}
                          validate={validate}
                          validationCallback={res =>
                            //console.log(res)
                            this.setState({
                              hasConfirmacionError: res,
                              validate: false
                            })
                          } // Optional.[Func].Default: none. Return the validation result.
                          onBlur={e => {
                            this.setState({ blur: true });
                          }} // Optional.[Func].Default: none. In order to validate the value on blur, you MUST provide a function, even if it is an empty function. Missing this, the validation on blur will not work.
                          validationOption={{
                            name: "nuevacontrasenaconfirmar", // Optional.[String].Default: "". To display in the Error message. i.e Please enter your ${name}.
                            check: true, // Optional.[Bool].Default: true. To determin if you need to validate.
                            required: true,
                            msgOnError: "Las contraseñas deben coincidir", // Optional.[Bool].Default: true. To determin if it is a required field.
                            customFunc: res => {
                              // Optional.[Func].Default: none. Custom function. Returns true or err message
                              // console.log(
                              //   contraseniaNueva,
                              //   contraseniaNuevaConfirmar
                              // );
                              if (res !== contraseniaNueva) {
                                //console.log(contraseniaNueva);
                                return "Las contraseñas deben coincidir";
                              }
                              return true;
                            }
                          }}
                        />

                        <p />
                        <Button className="bg-gradient-theme-left border-0" onClick={this.validateForm} >
                          <i className="fa fa-floppy-o" aria-hidden="true" /> {" CAMBIAR CONTRASEÑA"}
                        </Button>
                        <p></p>  
                        {this.props.datosCambioContrasenia.cambiarContraseniaOK && <Alert color="success"> <center> <p> Estimado Usuario. Su contraseña ha sido modificada exitosamente. </p> </center> </Alert>}
                        {this.props.datosCambioContrasenia.cambiarContraseniaError && <Alert color="warning"> <center> <p> {this.props.datosCambioContrasenia.msgErrorCambioContrasnia?this.props.datosCambioContrasenia.msgErrorCambioContrasnia:"No se pudo procesar su solicitud. Por favor intente más tarde."} </p> </center> </Alert>}
                      </form>
                    </CardBody>
                  </Card>
                </Col>
              </Row>
            </Page>
          </div>
        </main>
      </LoadingScreen>
    );
  }
}

const mapStateToProps = state => ({

  datosCambioContrasenia: state.datosCambioContrasenia,
  datosUsuario: state.datosUsuarios
});

const mapDispatchToProps = dispatch => {
  return {
    cambiarContrasenia: dataCambio =>
      dispatch(cambiarContraseniaFetch(dataCambio)),

    limpiarDatos: () => dispatch(limpiarCambioContrasenia())
  };
};

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(CambiarContrasenia)
);
